import LazyLoadImage from './LazyLoadImage';

export default LazyLoadImage;
